<template>
    <b-modal :title="Core.Definition.getDefinition('PDF')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                v-model="dataId"
                @onInit="onInit"
                @onSave="onSave"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                @onSaveSuccess="onSaveSuccess"
                :ignoreRouteParamId="true"
                getRoot="/binder-pdf"
                saveRoot="/binder-pdf"
                :options="dataOptions"
                :formStructure="dataFormStructures.form">
            <slot slot="afterForm">

                <InputMultipleInstanceSelector
                        ref="modalInstanceSelector"
                        v-model="dataBinderIndexes"
                        :emptyMessage="Core.Definition.getDefinition('Tous les indexes seront ajoutés au PDF')"
                        :description="Core.Definition.getDefinition('Indexes')"
                        :searchArgs="binderIndexSearchArgs"
                        :instanceSelector=" {
                        root: '/binder-index/list',
                        searchFormStructure: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        },
                        data: {},
                        options: {
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                            borderVariant: 'white',
                            noBody: true
                        },
                        columns: [
                                        {
                                            label: Core.Definition.getDefinition('#'),
                                            key: 'id',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Titre'),
                                            key: 'title',
                                            sortable: true
                                        }
                        ],
                        label: 'title',
                        id: 'id'
                    }"></InputMultipleInstanceSelector>

                <InputMultipleInstanceSelector
                        v-if="dataBinderIndexes.length > 0"
                        ref="modalInstanceSelector"
                        v-model="dataBinderForms"
                        :emptyMessage="Core.Definition.getDefinition('Tous les formulaires des indexes sélectionnés seront ajoutés au PDF')"
                        :description="Core.Definition.getDefinition('Formulaires')"
                        :searchArgs="binderFormSearchArgs"
                        :instanceSelector="{
                        root: '/binder-form/list',
                        searchFormStructure: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        },
                        data: {},
                        options: {
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                            borderVariant: 'white',
                            noBody: true
                        },
                        columns: [
                                        {
                                            label: Core.Definition.getDefinition('#'),
                                            key: 'id',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Titre'),
                                            key: 'title',
                                            sortable: true
                                        }
                        ],
                        label: 'title',
                        id: 'id'
                    }"></InputMultipleInstanceSelector>

                <b-alert show variant="warning">
                    {{Core.Definition.getDefinition('Cette opération peu prendre plusieurs minutes. Vous pourrez continuer à travailler durant le processus de création du PDF. Vous recevrez une notification lorsque le document sera prêt.')}}
                </b-alert>
            </slot>
        </DynamicForm>


    </b-modal>
</template>

<script>
    import DynamicForm from './DynamicForm'
    import InputMultipleInstanceSelector from './InputMultipleInstanceSelector'
    export default {
        name: 'ModalBinderPDF',
        components: {
            DynamicForm,
            InputMultipleInstanceSelector
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(val) {
                    this.dataId = val
                },
                get() {
                    return this.dataId
                }
            },
            binderId: {
                set(val) {
                    this.dataBinderId = val
                },
                get() {
                    return this.dataBinderId
                }
            },
            binderIndexSearchArgs: {
                set(val) {
                },
                get() {
                    let searchArgs = [{
                        key: 'binderId',
                        value: this.dataBinderId
                    }]
                    return searchArgs
                }
            },
            binderFormSearchArgs: {
                set(val) {
                },
                get() {

                    let binderIndexIds = []
                    for(let binderIndex in this.dataBinderIndexes) {
                        binderIndex = this.dataBinderIndexes[binderIndex]
                        if (binderIndex.id !== undefined) {
                            binderIndexIds.push(binderIndex.id)
                        }
                    }

                    let searchArgs = [{
                            key: 'binderIndexId',
                            value: binderIndexIds.join(',')
                    }]

                    return searchArgs
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataId: '',
                dataBinderId: '',
                dataBinderIndexId: '',
                dataBinderIndexes: [],
                dataBinderForms: [],
                dataBinderFormSearchArgs: [],
                dataOptions: {
                    submit: {
                        text: 'Créer',
                        variant: 'success'
                    }
                },
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'binderPDFStampId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'binderPDFSignatureId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayTableOfContents'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayAudits'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'lang'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'binderPDFStampId',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Étampe'),
                                value: '',
                                onSelect: function() {}
                            },
                            {
                                id: 'lang',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Langue'),
                                value: {
                                    value: 'fr-CA',
                                    label: 'Français'
                                },
                                onSelect: function() {}
                            },
                            {
                                id: 'binderPDFSignatureId',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Signature'),
                                value: '',
                                onSelect: function() {}
                            },
                            {
                                id: 'displayTableOfContents',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Afficher la table des matières'),
                                value: true,
                                onChange: function(val, form, fieldRefs) {}
                            },
                            {
                                id: 'displayAudits',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Afficher l\'audit de changements'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInit() {
                this.$refs.dynamicForm.dataId = ''
                this.$refs.dynamicForm.$refs.request.addArg('binderId', this.dataBinderId)
            },
            onSave() {
                let binderIndexIds = []
                for(let binderIndex in this.dataBinderIndexes) {
                    binderIndex = this.dataBinderIndexes[binderIndex]
                    if (binderIndex.id !== undefined) {
                        binderIndexIds.push(binderIndex.id)
                    }
                }
                this.$refs.dynamicForm.$refs.request.addArg('binderIndexes', binderIndexIds)

                let binderFormIds = []
                for(let binderForm in this.dataBinderForms) {
                    binderForm = this.dataBinderForms[binderForm]
                    if (binderForm.id !== undefined) {
                        binderFormIds.push(binderForm.id)
                    }
                }
                this.$refs.dynamicForm.$refs.request.addArg('binderForms', binderFormIds)
            },
            onRequestSuccess(data, method) {
                this.$refs.dynamicForm.dataId = ''
            },
            onInitSuccess(data) {
                this.$emit('onInitSuccess', data)
            },
            onSaveSuccess(data) {
                this.$emit('onSaveSuccess', data)
            }
        }
    }
</script>
